import ProductCard from 'app/components/cards/ProductCard'
import useCurrencyState from 'app/hooks/useCurrencyState'
import { LISTING_STATUS } from 'app/utils/constants/status.constants'
import { getFirstUrlAttachment } from 'app/utils/helpers/functions.helpers'

type ProductCardRenderItemProps = {
  item: ListingModel
  loading?: boolean
  isBusinessUser?: boolean
}

const ProductCardRenderItem: RFC<ProductCardRenderItemProps> = ({
  item,
  loading,
  isBusinessUser
}) => {
  const { currency } = useCurrencyState()
  const location =
    item.shipping?.dispatch_address?.city ||
    item.shipping?.collection_address?.city ||
    ''
  const link = `/listing/${item.slug}`
  const isSold = item.status === LISTING_STATUS.sold_out
  const isReserved = item.status === LISTING_STATUS.reserved
  const commonPrice = item.converted_actual_price || item.actual_price
  const tradePrice = item.converted_trade_price || item.trade_price
  const image =
    item?.primary_attachment?.url ||
    getFirstUrlAttachment(item?.attachments) ||
    ''

  const isTradePricing = !!item?.trade_pricing
  const showTradePrice = isBusinessUser && isTradePricing
  const price = showTradePrice ? Number(tradePrice) : commonPrice

  return (
    <ProductCard
      location={location}
      image={image}
      title={item.title}
      subTitle={item.subtitle}
      price={price}
      currency={currency}
      auctionEndDate={item.auction?.end_date}
      auctionReserveStatus={item.auction?.reserve_status}
      link={link}
      id={item.id}
      isLiked={item.liked}
      isSold={isSold}
      loading={loading}
      listingUserId={item?.user?.id}
      isReserved={isReserved}
      isTradePricing={isTradePricing}
      isBusinessUser={isBusinessUser}
    />
  )
}

export default ProductCardRenderItem
